import { AfterViewInit, Component, ElementRef, EventEmitter, Input, NgZone, OnDestroy, Output } from '@angular/core';
import { Chart, ChartData, ChartOptions, Plugin } from 'chart.js';

import { SankeyController, Flow } from '../../../lib/chartjs-sankey-custom/src/index.esm';

@Component({
  selector: 'app-sankey',
  templateUrl: './sankey.component.html',
  styleUrl: './sankey.component.scss'
})
export class SankeyComponent implements AfterViewInit, OnDestroy {

  @Input() plugins: Plugin[] = [];

  @Input() get data(): ChartData {
    return this._data;
  }

  @Input() height: number = 200;

  set data(val: any) {
    this._data = val;
    this.reinit();
  }

  @Input() get options(): ChartOptions {
    return this._options;
  }

  set options(val: ChartOptions) {
    this._options = val;
    this.reinit();
  }

  @Output() canvasClicked: EventEmitter<any> = new EventEmitter<any>();

  initialized: boolean | undefined;

  _data: ChartData;

  _options: ChartOptions = {};

  chart: Chart | null;

  constructor(
    public el: ElementRef,
    private zone: NgZone,
  ) {}

  ngAfterViewInit() {
    this.registerController();
    this.initChart();
    this.initialized = true;
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
      this.initialized = false;
      this.chart = null;
    }
  }

  registerController() {
    Chart.register(SankeyController, Flow);
  }

  initChart() {
    this.zone.runOutsideAngular(() => {
      this.chart = new Chart(this.canvas, {
        type: 'sankey',
        data: this.data,
        options: this.options,
        plugins: this.plugins,
      });
    });
  }

  reinit() {
    if (this.chart) {
      this.chart.destroy();
      this.initChart();
    }
  }

  get canvas() {
    return this.el.nativeElement.children[0].children[0];
  }

  get style() {
    return {
      position: 'relative',
      height: `${this.height}px`,
    };
  }

  onCanvasClick(event: Event) {
    if (this.chart) {
      const points = this.chart.getElementsAtEventForMode(event, 'nearest', { intersect: true }, true);

      if (points.length) {
        const firstPoint = points[0];
        const value = this.chart.data.datasets[firstPoint.datasetIndex].data[firstPoint.index];
        this.canvasClicked.emit({ originalEvent: event, value });
      } else {
        this.canvasClicked.emit({ originalEvent: event, value: null });
      }
    }
  }
}
